import { render, staticRenderFns } from "./CreateCustomDocField.vue?vue&type=template&id=1e7dfba3&scoped=true&"
import script from "./CreateCustomDocField.vue?vue&type=script&lang=js&"
export * from "./CreateCustomDocField.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomDocField.vue?vue&type=style&index=0&id=1e7dfba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7dfba3",
  null
  
)

export default component.exports